// @ts-nocheck
import React, { useEffect, useMemo, useRef } from 'react';
import { useTranslation } from 'react-i18next';
import { CardExpandToggler } from '@components/card/card';
import KpiTable from './KpiTable';

const TableChart = ({ data }) => {
  const { t } = useTranslation();

  // تحويل البيانات إلى الصيغة المتوقعة من ReportTable
  const { tableData, columns } = useMemo(() => {
    if (!data || !data.data || !data.kpiNames) {
      return { tableData: [], columns: [] };
    }

    const { kpiNames, data: originalData } = data;

    // إنشاء الأعمدة
    const generatedColumns = [
      {
        key: 'name',
        // title: `<i class="fa fa-chart-bar"></i>`,
        title: <i className='fa fa-star text-theme me-2 small'></i>,
        sortable: true,
        className: 'bg-theme bg-opacity-30 w-10 fw-bold'
      },
      ...kpiNames.map(col => ({
        key: col,
        title: col,
        sortable: true
      }))
    ];

    // تحويل البيانات
    const generatedTableData = originalData.map(row => {
      const rowData = { name: row.name };

      row.data.forEach((item, index) => {
        rowData[kpiNames[index]] = item.value;
      });

      return rowData;
    });

    return { tableData: generatedTableData, columns: generatedColumns };
  }, [data]);

  if (!data || !data.data || !data.kpiNames) {
    return <div>{t('NoDataAvailable')}</div>;
  }

  return (
    <>
      <div className='d-flex fw-bold small p-3 bg-theme bg-opacity-20 align-items-center'>
        <span className='flex-grow-1 d-flex align-items-center gap-2 fw-bold fs-6'>
          <i className='fa fa-file-text text-theme '></i>
          {data?.title}
        </span>
      </div>

      <div className='p-3'>
        <KpiTable
          data={tableData}
          columns={columns}
          ReportName={data?.title}
          enableSearch={true}
          showRecordsSelector={true}
          tableClass='table table-sm table-bordered table-hover text-nowrap w-100'
          theadClass='fw-bold bg-theme bg-opacity-30'
        />
      </div>

      {/* <div className='p-3'>
        <table ref={tableRef} className='table table-bordered table-hover text-nowrap w-100'>
          <thead className='fw-bold bg-theme bg-opacity-30'>
            <tr>
              <th>{t('Name')}</th>
              {columns.map((col, index) => (
                <th key={index}>{col}</th>
              ))}
            </tr>
          </thead>
          <tbody>
            {tableData.map((row, rowIndex) => (
              <tr key={rowIndex}>
                <td>{row.name}</td>
                {row.data.map((item, colIndex) => (
                  <td key={colIndex}>{item.value}</td>
                ))}
              </tr>
            ))}
          </tbody>
        </table>
      </div> */}
    </>
  );
};

export default TableChart;
